module.exports = __webpack_public_path__ + "img/concrete-pump.b51fb0e.png";